const LIVE_SESSION_KEY = 'crm.liveSession';
const LEGACY_API_TOKEN_KEY = 'token';

export function persistLiveSession(): void {
  window.localStorage.setItem(LIVE_SESSION_KEY, '1');
  window.localStorage.removeItem(LEGACY_API_TOKEN_KEY);
}

export function clearLiveSession(): void {
  window.localStorage.removeItem(LIVE_SESSION_KEY);
  window.localStorage.removeItem(LEGACY_API_TOKEN_KEY);
}

export function hasLiveSession(): boolean {
  return window.localStorage.getItem(LIVE_SESSION_KEY) === '1';
}
